import { Component, Inject, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { PromoService } from 'src/app/assabil-sales/services/pomo-service';
import { Promo } from 'src/app/assabil-sales/models/entities/promo-entity';
import { PromoPipe } from 'src/app/assabil-sales/pipes/promo-pipe';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';
@Component({
    selector: 'promo-lov',
    templateUrl: './promo-lov.component.html',
    styleUrls: ['./promo-lov.component.scss']
})

export class PromoLovComponent extends GenericLovComponent {
      
    // Filter fields
  // ---------------------------------------------------
    promoCode          : string;
    name               : string;
    promoTypeCode      : string;
    progressLevel      : number;
    startDate          : Date = null;
    endDate            : Date = null;
    // ---------------------------------------------------


  // ---------------------------------------------------
    promos          : Promo[] = [];
    sourcePromos    : Promo[] = [];
    selectedPromos  : Promo[] = [];
    dual            : boolean = false;
    returnList      : boolean = false;  
  // ---------------------------------------------------

  promoPipe               : PromoPipe = new PromoPipe();

  columns = [
      { prop: 'promoCode',       name: 'Code',               style: {'font-weight': 'bold', 'font-style': 'italic'}},
      { prop: 'name',            name: 'Nom'                                                                       },
      { prop: 'progressLevel',   name: 'Niv. Progression ',                                                        }, 
      { prop: 'sequence',        name: 'Sequence',                                                                 }, 
  ]

  constructor(
    public dialogRef: MatDialogRef<PromoLovComponent>,  @Inject(MAT_DIALOG_DATA) public data: any,
    protected promoService  : PromoService,
    protected toastr        : ToastrService,
    protected router        : Router,
    protected location      : Location) {
      super();
      this.promos     = data.promos;
      this.dual       = data.dual;
      this.returnList = data.returnList;
  }

  //----------------------------------------------------------------------------------------------------------------
   ngOnInit() {
     super. ngOnInit();
      this.setData();
  }
  //----------------------------------------------------------------------------------------------------------------


  //----------------------------------------------------------------------------------------------------------------
  loadData() {
      this.promoService.promosGet(this.promoCode, this.name, this.progressLevel, this.startDate, this.endDate).then(result => {
        this.promos = result;
        this.setData();
      });
  }
  //----------------------------------------------------------------------------------------------------------------

  //----------------------------------------------------------------------------------------------------------------
  setData() {
    if (! this.promos ) return;
    this.sourcePromos  = [...this.promos];
  }
  //----------------------------------------------------------------------------------------------------------------



  //----------------------------------------------------------------------------------------------------------------
  addToSelected(promo : Promo){
    this.selectedPromos.push(promo);
    this.sourcePromos.splice(this.sourcePromos.indexOf(promo),1)
    this.sourcePromos   = [...this.sourcePromos]
    this.selectedPromos = [...this.selectedPromos]
  }
  //----------------------------------------------------------------------------------------------------------------

  //----------------------------------------------------------------------------------------------------------------
  removeFromSelected(promo: Promo){
    this.sourcePromos.push(promo);
    this.selectedPromos.splice(this.selectedPromos.indexOf(promo),1)
    this.sourcePromos   = [...this.sourcePromos]
    this.selectedPromos = [...this.selectedPromos]
  }
//----------------------------------------------------------------------------------------------------------------
  

//----------------------------------------------------------------------------------------------------------------
  addAll(){
    this.sourcePromos   = [];
    this.selectedPromos = [...this.promos];
  }
  removeAll(){
    this.sourcePromos   = [...this.promos];
    this.selectedPromos = [];
  }
//----------------------------------------------------------------------------------------------------------------
      

//----------------------------------------------------------------------------------------------------------------
closeModal(promo : Promo){
  if (this.returnList || this.dual) {
    let result = {promos : null, promo : null, selectedPromos : null};
    result.promo             = promo;
    result.selectedPromos    = this.selectedPromos;
    result.promos            = this.promos;
    this.dialogRef.close(result);
  } else {
    this.dialogRef.close(promo);
  }
}
//----------------------------------------------------------------------------------------------------------------

}


